import {
  FETCH_LOCATION_INSIGHTS,
  FETCH_LOCATION_INSIGHTS_FAILURE,
  FETCH_LOCATION_INSIGHTS_SUCCESS,
} from "./constants";

const initialState = {
  isLoading: false,
  error: null,
  report: null,
};

const LocationInsightsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LOCATION_INSIGHTS:
      return { ...state, isLoading: true, error: null, report: null };
    case FETCH_LOCATION_INSIGHTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        report: action.payload,
        error: null,
      };
    case FETCH_LOCATION_INSIGHTS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};

export default LocationInsightsReducer;
